export const GET_ALL_USER_CARDS = null;
export const CREATE_PAYMENT_INTENT = null;
export const PAYMENT_INTENT_DATA = null;
export const CLEAR_PAYMENT_INTENT_DATA = null;
export const PAYMENT_SUCCESS = null;
export const PAYMENT_FAIL = null;
export const GET_VALIDATE_COUPON = null;
export const CLEAR_COUPON = null;
export const GET_TAX_DETAILS = null;
